import type { DefineComponentProps } from "../types.ts";

/**
 *
 *
 *
 *
 *
 */
export const createObservedAttributes = (
  props: DefineComponentProps<Record<string, unknown>>,
): string[] => Object.entries(props).map(([key, { attribute }]) => (attribute ? attribute : key));
